import { useState } from "react";

import { toast } from "react-toastify";
import { Asset_Delete, Promo_delete } from "../../../api/api";
import icroundsearch from "../../../assets/svg/Assetmanagemant/search.svg";
import ImageBlock from "../../../component/Common/ImageBlock";
import NoData from "../../../component/Common/NoData";
import VideoThumbnail from "../../../component/Common/VideoThumbnail";
import Loader from "../../../component/Loader/Loader";
import Partitioncontent from "../../../component/content-update/Partitioncontent";
import UploadPosters from "../../../component/content-update/uploadposter";
import Videoplayer from "../../../component/player-block/Videoplayer";
import SearchBar from "../../../component/search-bar/searchBar";
import VideoBlock from "../../../component/Common/VideoBlock";
import { posterimage } from "../../../service/commonFunc";
import "./CmsChannelDetail.scss";
import "./SearchData.scss";
import appStore from "../../../Config/Store/appStore";
import { observer } from "mobx-react";
import { toJS } from "mobx";

const SearchData = observer(
  ({
    searchdata,
    AssetSearch,
    searchQuerys,
    assetdetail,
    permission,
    fillerDeleteConfirm,
    deletepopup,
    promoDeleteConfirm,
    uplaodassetposter,
  }) => {
    const AssetPartnerDetail = JSON.parse(
      localStorage.getItem("AssetPartnerDetail")
    );
    const contentArray = searchdata;
    const Query = searchQuerys;
    const tabs = ["PROGRAM", "PROMO", "FILLER", "POSTERS"];
    const [partition, setpartition] = useState(false);
    const [posterpartion, setposterpartion] = useState(false);
    const [postermeta, setpostermeta] = useState(true);
    const [selectedVideoData, setSelectedVideoData] = useState(null);
    const [selectedPosterData, setSelectedPosterData] = useState(null);
    // const [assetSignledata, setAssetSignledata] = useState(null);
    const [showplayer, setshowplayer] = useState(false);

    const [programVid, setprogramVid] = useState(null);
    const [isContentLoading, setIsContentLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("PROGRAM");
    const [searchQuery, setSearchQuery] = useState("");
    const [searchData, setSearchData] = useState(null);
    const programVideos = contentArray?.programs;
    const promosVideos = contentArray?.promos;
    const fillersVideos = contentArray?.programs.filter(
      (item) => item.assetType === "VIDEO" && item.videoType === "FILLER"
    );
    const PostersData = contentArray?.posters;

    const postertab = (data) => {
      appStore.setAssetSignledata(toJS(data));
    };
    const onArchiveClick = async (e) => {
      e.stopPropagation();
    };

    const assetDeleteConfirm = (assetid, e) => {
      e.stopPropagation();
      console.log("deletepopup", deletepopup);
      deletepopup(e, assetid, "asset");
    };
    const handleTabClick = (tab) => {
      setpartition(false);
      setActiveTab(tab);
      if (tab === "POSTERS") {
        setposterpartion(true);
      } else {
        setposterpartion(false);
      }
      appStore.setAssetSignledata(null);
    };
    const itemCount = (tab) => {
      let count = 0;
      if (tab === "PROGRAM") {
        count = programVideos.length;
      } else if (tab === "PROMO") {
        count = promosVideos.length;
      } else if (tab === "FILLER") {
        count = fillersVideos.length;
      } else count = PostersData.length;

      return count;
    };
    const opendata = (data, bool, e) => {
      if (e && e.stopPropagation) {
        e.stopPropagation();
      }

      setposterpartion(false);
      setpartition(true);
      const plainData = toJS(data);
      appStore.setAssetSignledata(plainData);
      setSelectedVideoData(plainData);
    };

    const onUploadPosterClick = (data, e) => {
      if (e && e.stopPropagation) {
        e.stopPropagation();
      }

      setpartition(false);
      setposterpartion(true);
      const plainData = toJS(data);
      appStore.setAssetSignledata(plainData);
      setSelectedPosterData(plainData);
    };

    const assetdelete = async (assetid) => {
      setpartition(false);
      const deleteasset = await Asset_Delete(assetid);

      assetdetail(AssetPartnerDetail);
    };

    const databymeta = (data) => {
      appStore.setAssetSignledata(toJS(data));
    };

    const handleKeyPress = async (e) => {
      if (!e || e.length === 0) {
        window.location.reload();
      }
      if (e.length >= 3 || e.length < 1) {
        setIsContentLoading(true);
        try {
          const result = await AssetSearch(e);
          setSearchData(result);
        } catch (err) {
          toast.error("Search failed. Please try again.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
        } finally {
          setIsContentLoading(false);
        }
      }
    };
    const [expandMeta, setExpandMeta] = useState(true);
    const [ismetadata, setIsmetadata] = useState(true);
    const expandMetaView = () => {
      setExpandMeta(false);
      setIsmetadata(true);
    };

    const openplayerdata = (data) => {
      setprogramVid(programVideos);
      appStore.setAssetSignledata(toJS(data));

      setshowplayer(true);
    };

    const closeplayer = () => {
      setshowplayer(false);
    };

    return (
      <div className="">
        {showplayer ? (
          <Videoplayer
            closepartition={() => closeplayer()}
            videodata={toJS(appStore.assetSignledata)}
            assetdetail={() => assetdetail(AssetPartnerDetail)}
            programVideos={programVid}
            databymeta={databymeta}
            searchQuerys={Query}
            AssetSearch={AssetSearch}
          />
        ) : (
          <div className="dashboard-content">
            <div className="top-content">
              <div className="left-side">
                <div className="breadcrumbs">
                  <ul>
                    <li>
                      <a href="/asset">Asset Management</a>
                    </li>
                    <li>
                      <a href="/CmsChannelDetail">{AssetPartnerDetail?.name}</a>
                    </li>
                    <li className="active">Search Results</li>
                  </ul>
                </div>
              </div>
              <SearchBar
                searchQuery={searchQuery}
                searchValue={Query}
                placeholder="Search using Filename..."
                searchOutput={handleKeyPress}
                keyEnter={false}
                icon={icroundsearch}
              />
            </div>
            <div className="search-top">
              <div className="searchQuery">Search results for " {Query} "</div>

              <div className="searchResults">
                Search Results : {contentArray.totalResults}
              </div>
            </div>

            {isContentLoading ? (
              <div
                style={{
                  background: "rgb(18, 18, 18, 0.6)",
                  height: "50vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 9999,
                  borderRadius: "8px",
                }}
              >
                <Loader />
              </div>
            ) : (
              <div className="row">
                <div
                  className={
                    partition || posterpartion ? "col-8 partitionOn" : "col-12"
                  }
                >
                  <div className="channel-content">
                    <div className="channel-top">
                      <div className="left-side">
                        <ul className="tabs">
                          {tabs.map((tab) => {
                            return (
                              <li
                                className={`tab-a ${
                                  activeTab === tab ? "active" : ""
                                }`}
                                onClick={() => handleTabClick(tab)}
                              >
                                {tab + ` (${itemCount(tab)})`}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                    <div className="content-wrapper">
                      {activeTab === "PROGRAM" && (
                        <div className="video-channel-list">
                          {programVideos.length > 0 ? (
                            programVideos.map((data) => {
                              let image = posterimage(data);
                              return (
                                <VideoBlock
                                  assetSignledata={appStore.assetSignledata}
                                  k
                                  key={data.id} // Add a unique key
                                  data={data}
                                  onVideoClick={opendata}
                                  onUploadPosterClick={(e) => {
                                    if (e && e.stopPropagation) {
                                      e.stopPropagation();
                                    }

                                    onUploadPosterClick(data);
                                  }}
                                  onDeleteClick={assetDeleteConfirm}
                                  // onArchiveClick={onArchiveClick}
                                  onUploadPromos={uplaodassetposter}
                                  image_url={image}
                                  openplayercomp={openplayerdata}
                                  permission={permission}
                                  partitionOn={partition}
                                />
                              );
                            })
                          ) : (
                            <NoData />
                          )}
                        </div>
                      )}
                      {activeTab === "PROMO" && (
                        <div className="video-channel-list">
                          {promosVideos.length > 0 ? (
                            promosVideos.map((data, index) => {
                              return (
                                <VideoThumbnail
                                  data={data}
                                  openplayerdata={openplayerdata}
                                  index={index}
                                  deleteFunction={(e) =>
                                    promoDeleteConfirm(data.id, e)
                                  }
                                  permission={permission}
                                />
                              );
                            })
                          ) : (
                            <NoData />
                          )}
                        </div>
                      )}
                      {activeTab === "FILLER" && (
                        <div className="video-channel-list">
                          {fillersVideos.length > 0 ? (
                            fillersVideos.map((data, index) => {
                              return (
                                <VideoThumbnail
                                  data={data}
                                  openplayerdata={openplayerdata}
                                  index={index}
                                  deleteFunction={(e) => fillerDeleteConfirm(e)}
                                  permission={permission}
                                />
                              );
                            })
                          ) : (
                            <NoData />
                          )}
                        </div>
                      )}
                      {activeTab === "POSTERS" && (
                        <div className="video-channel-list">
                          {PostersData.length > 0 ? (
                            programVideos.map((data, index) => {
                              let image = posterimage(data);
                              return (
                                <ImageBlock
                                  image={image}
                                  data={data}
                                  postertab={onUploadPosterClick}
                                  deletepopup={deletepopup}
                                  permission={permission}
                                  assetSignledata={data}
                                  index={index}
                                />
                              );
                            })
                          ) : (
                            <NoData />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {partition && (
                  <Partitioncontent
                    assetdetail={() => assetdetail(AssetPartnerDetail)}
                    expandMetaView={() => expandMetaView()}
                    videodata={selectedVideoData} // <-- use local state here
                    closepartition={() => {
                      setpartition(false);
                    }}
                  />
                )}

                {posterpartion && (
                  <UploadPosters
                    videodata={selectedPosterData} // <-- use local state here
                    assetdetail={() => assetdetail(AssetPartnerDetail)}
                    permission={permission}
                  />
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
);

export default SearchData;
